import {
  DataTableProps,
  SortableTableProps,
  SimplePaginationProps,
} from '@dixa/lib-shared-habla';
import type {
  SearchConversationEnriched,
  SearchSortField,
} from 'lib-search-types';
import { AsyncStatus } from 'lib-shared-types-api';
import { PropsWithClassName } from 'lib-shared-types-utils';

export type ConversationsTableProps = PropsWithClassName & {
  conversations: readonly SearchConversationEnriched[];
  asyncStatus: AsyncStatus;
  selectableRowsProps?: DataTableProps<
    SearchConversationEnriched,
    never
  >['selectableRowsProps'];
  paginationProps?: SimplePaginationProps;
  sortingProps?: SortableTableProps;
};

export type ConversationsTableSortableField =
  (typeof conversationsTableSortableFields)[number];

export const conversationsTableSortableFields = [
  'created_at',
  'last_message_created_at',
] satisfies SearchSortField<'conversations'>[];
